export enum Type {
    CHART = 'chart',
    FLOW = 'flow',
    DIFF = 'diff',
    NET = 'net',
    DEFAULT = 'default',
}
